module.exports = __webpack_public_path__ + "img/zero_screen-frame.6bb8d21a.webp";